module.exports = __webpack_public_path__ + "img/invite-a-friend-schema.67c12a56.svg";